export default "import Home from \"./Home\";\n\nexport function App() {\n  return (\n    <Home name=\"测试标题\">\n      <div>信息</div>\n    </Home>\n  );\n}\n"